import { render, staticRenderFns } from "./WebsiteDoctorForm.vue?vue&type=template&id=44635d7a&"
import script from "./WebsiteDoctorForm.vue?vue&type=script&lang=js&"
export * from "./WebsiteDoctorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports